import {Duration} from '../duration';

export const HUMANIA_EMMA_MIN_AGE = 18;
export const HUMANIA_EMMA_MAX_TOTAL_COVERAGE_ELITE = 1000000;
export const HUMANIA_EMMA_MAX_TOTAL_COVERAGE_SUPERIOR = 500000;
export const HUMANIA_EMMA_MAX_TOTAL_COVERAGE_STANDARD = 300000;

// V2
export const HUMANIA_EMMA_V2_ELIGIBILITY_MAX_AGE = 79;
export const HUMANIA_EMMA_V2_MAX_TERM_AGE = 70;
export const HUMANIA_EMMA_V2_DISABILITY_RIDER_MAX_AGE = 60;
export const HUMANIA_EMMA_V2_CANCER_RIDER_MAX_AGE = 70;
export const MAX_AGE_P65_AND_V20 = 45;

export const HUMANIA_EMMA_V2_MIN_WHOLE_COVERAGE = 1_000;
export const HUMANIA_EMMA_V2_MIN_TERM_COVERAGE = 50_000;
export const HUMANIA_EMMA_V2_MAX_COVERAGE = 5_000_000;
export const HUMANIA_EMMA_V2_CANCER_RIDER_MIN_COVERAGE = 10_000;
export const HUMANIA_EMMA_V2_CANCER_RIDER_MAX_COVERAGE = 75_000;
export const HUMANIA_EMMA_V2_DISABILITY_RIDER_MIN_COVERAGE = 500;

export const HUMANIA_EMMA_V2_MIN_BMI = 17.1;
export const HUMANIA_EMMA_V2_MAX_BMI = 44;
export const HUMANIA_EMMA_V2_AUTOMATIC_SURCHARGE_BMI = 38;

export const HUMANIA_EMMA_V2_COVERAGE_AMOUNT_INTERVAL = 1_000;
export const HUMANIA_EMMA_V2_CANCER_RIDER_COVERAGE_AMOUNT_INTERVAL_EMMA_PRO = 5_000;
export const HUMANIA_EMMA_V2_CANCER_RIDER_COVERAGE_AMOUNT_INTERVAL_EMMA_APP = 15_000;
export const HUMANIA_EMMA_V2_DISABILITY_RIDER_COVERAGE_AMOUNT_INTERVAL = 100;

// This insurer code is Emma's code for all Humania providers
export const HUMANIA_EMMA_INSURER_CODE = '263854';

export const MAX_CONVERSION_AGE = 65;
export const TERMINATION_AGE = 80;

export enum HUMANIA_EMMA_CHILD_RIDER {
  NONE = 0,
  OPTION_15K = 15000,
  OPTION_20K = 20000,
  OPTION_25K = 25000,
}

export const HUMANIA_EMMA_V2_CHILD_RIDER_COVERAGES = [15_000, 20_000, 25_000];
export const HUMANIA_EMMA_V2_TERM_LIFE_DURATIONS = [
  Duration.T10,
  Duration.T11,
  Duration.T12,
  Duration.T13,
  Duration.T14,
  Duration.T15,
  Duration.T16,
  Duration.T17,
  Duration.T18,
  Duration.T19,
  Duration.T20,
  Duration.T21,
  Duration.T22,
  Duration.T23,
  Duration.T24,
  Duration.T25,
  Duration.T26,
  Duration.T27,
  Duration.T28,
  Duration.T29,
  Duration.T30,
  Duration.T31,
  Duration.T32,
  Duration.T33,
  Duration.T34,
  Duration.T35,
];
export const HUMANIA_EMMA_V2_WHOLE_LIFE_DURATIONS = [Duration.P100, Duration.P65, Duration.V20];

export const HUMANIA_EMMA_TERM_LIFE_DURATIONS = [Duration.T1, Duration.T10, Duration.T20];
export const HUMANIA_EMMA_WHOLE_LIFE_DURATIONS = [Duration.T100];
export const HUMANIA_EMMA_DURATIONS = HUMANIA_EMMA_TERM_LIFE_DURATIONS.concat(
  HUMANIA_EMMA_WHOLE_LIFE_DURATIONS,
);
export const HUMANIA_EMMA_V2_DURATIONS = HUMANIA_EMMA_V2_TERM_LIFE_DURATIONS.concat(
  HUMANIA_EMMA_V2_WHOLE_LIFE_DURATIONS,
);

export const HUMANIA_EMMA_CHILD_RIDER_COVERAGES_AND_ANNUAL_PRICES = new Map([
  [HUMANIA_EMMA_CHILD_RIDER.OPTION_15K, 75],
  [HUMANIA_EMMA_CHILD_RIDER.OPTION_20K, 100],
  [HUMANIA_EMMA_CHILD_RIDER.OPTION_25K, 125],
]);

export const HUMANIA_EMMA_CHILD_RIDER_COVERAGES_AND_PRICES = new Map<HUMANIA_EMMA_CHILD_RIDER, number>([
  [HUMANIA_EMMA_CHILD_RIDER.OPTION_15K, 6.75],
  [HUMANIA_EMMA_CHILD_RIDER.OPTION_20K, 9],
  [HUMANIA_EMMA_CHILD_RIDER.OPTION_25K, 11.25],
]);

export enum ContractSpecimenFile {
  EN_HUMANIA_EMMA_V2_SPECIMEN = 'contract_specimen.pdf',
  FR_HUMANIA_EMMA_V2_SPECIMEN = 'spécimen_de_contrat.pdf',
}

export enum ProductSummaryFile {
  EN_HUMANIA_EMMA_V2_WHOLE_LIFE_SUMMARY = 'EN_WHOLE_LIFE_SUMMARY.pdf',
  EN_HUMANIA_EMMA_V2_TERM_LIFE_SUMMARY = 'EN_TERM_LIFE_SUMMARY.pdf',
  FR_HUMANIA_EMMA_V2_WHOLE_LIFE_SUMMARY = 'FR_WHOLE_LIFE_SUMMARY.pdf',
  FR_HUMANIA_EMMA_V2_TERM_LIFE_SUMMARY = 'FR_TERM_LIFE_SUMMARY.pdf',
}
